import {
  Box,
  Divider,
  Stack,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import viewpaths from "global/constants/ViewPathConstants";
import CenteredAuthenticatedLayout from "layouts/CenteredAuthenticated/CenteredAuthenticatedLayout";
import { ChangeEvent, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import history from "utils/history";
import Domains from "../Domains/Domains";
import Senders from "./Senders";

const tabs = [
  {
    label: "Senders",
    value: "Senders",
    key: "senders",
    disabled: false,
  },
  {
    label: "Domains",
    value: "Domains",
    key: "domains",
    disabled: false,
  },
  {
    label: "Dedicated IPs (Coming Soon)",
    value: "Dedicated IPs (Coming Soon)",
    key: "dedicated-ips",
    disabled: true,
  },
];

const SendersDomains = () => {
  const getTab = new URLSearchParams(useLocation().search).get("tab");

  const fetchTab = (
    selectedTab: string = "",
    searchBasedOn: "label" | "key"
  ) => {
    const newSelection = tabs.find((tab) => tab[searchBasedOn] === selectedTab);
    return newSelection;
  };

  useEffect(() => {
    const tabToSelect = fetchTab(getTab ?? "", "key");
    setCurrentTab(tabToSelect?.label ?? tabs[0].value);
  }, [getTab]);

  const tabToSelect = fetchTab(getTab ?? "", "key");

  const [currentTab, setCurrentTab] = useState(
    tabToSelect?.label ?? tabs[0].label
  );

  const handleTabsChange = useCallback(
    (event: ChangeEvent<any>, value: string): void => {
      const selectedTab = fetchTab(value, "label");
      history.replace(`${viewpaths.settingsViewPath}?tab=${selectedTab!.key}`);
      setCurrentTab(value);
    },
    []
  );

  const getPageHeader = () => {
    return (
      <>
        <Stack
          sx={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h5" color="text.primary" fontWeight={700}>
              Senders, Domains & Dedicated IPs
            </Typography>
          </Stack>
        </Stack>
        <Stack direction="column">
          <Box>
            <Tabs
              indicatorColor="primary"
              onChange={handleTabsChange}
              scrollButtons="auto"
              textColor="primary"
              value={currentTab}
              variant="scrollable"
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  disabled={tab.disabled}
                />
              ))}
            </Tabs>
            <Divider />
          </Box>
        </Stack>
      </>
    );
  };

  const getPageBody = () => {
    switch (currentTab) {
      case "Senders":
        return <Senders />;
      case "Domains":
        return <Domains />;
      default:
        break;
    }
  };

  const getPage = () => {
    return (
      <Stack direction="column" spacing={1}>
        {getPageHeader()}
        <Box pt={1}>{getPageBody()}</Box>
      </Stack>
    );
  };

  return <CenteredAuthenticatedLayout>{getPage()}</CenteredAuthenticatedLayout>;
};

export default SendersDomains;
